import { Role } from 'constants/roles';

import { useMemo } from 'react';

import { usePermissions } from './usePermissions';

export const useCheckFinanceAccess = () => {
  const { roles } = usePermissions();

  return {
    isHaveFinanceAccess: useMemo(() => {
      return (
        roles.includes(Role.Admin) ||
        roles.includes(Role.Tech) ||
        roles.includes(Role.Finance) ||
        roles.includes(Role.FinanceLead)
      );
    }, [roles]),
  };
};
